<template>
  <div id="">
    <header class="emd-header _mode_dark">
      <nav class="emd-navbar">
        <div class="emd-navbar__brand">
            <a href="#" class="emd-logo-link">
              <img src="@/assets/hub-logo.svg" class="emd-logo-link__image" alt="Logo Hub" />
            </a>
        </div>
        <div class="emd-navbar__control">
          <div class="emd-navbar__right">
            <div v-if="profile.isLoading" class="login-skeleton" :class="classSkeleton"></div>
            <div v-else class="emd-dropdown _position_right jsDropdown">
              <div class="emd-dropdown__trigger jsDropdownTrigger" @click.prevent="toggleDesktopMenu">
                <div class="emd-flex _align_center">
                  <div class="emd-flex-item _shrink">
                    <div class="emd-avatar">
                      <div class="emd-avatar__placeholder">{{userInitials}}</div>
                    </div>
                  </div>
                  <div class="emd-flex-item">
                    <p class="emd-text _size_small emd-link">{{name}}</p>
                    <p class="emd-text _size_small _style_caption emd-link">{{profile.user.email}} <i class="uil uil-angle-down"></i></p>
                  </div>
                </div>
              </div>
              <div id="menuContent" class="emd-dropdown__content _mode_light jsDropdownContent" ref="menuContent">
                <div class="emd-accordion">
                  <a :href="profileUrl">
                    <label class="emd-accordion__label">
                      <i class="uil uil-user"></i>
                      <span>{{ $t("header.profile") }}</span>
                    </label>
                  </a>
                </div>
                <div class="emd-accordion _color_danger" @click="logout">
                  <label class="emd-accordion__label">
                    <i class="uil uil-sign-out-alt"></i>
                    <span>{{ $t("header.logout") }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="emd-navbar__trigger">
            <button class="emd-btn _color_clear _type_outline _size_small jsMobileMenuOpen" @click="toggleMenu">Menu</button>
          </div>
        </div>
      </nav>
    </header>

    <div class="emd-mobile-menu ">
      <div class="emd-mobile-menu__header">
        <div class="emd-flex">
          <div class="emd-flex-item _shrink">
            <div class="emd-avatar">
              <div class="emd-avatar__placeholder">{{userInitials}}</div>
            </div>
          </div>
          <div class="emd-flex-item">
            <p class="emd-text _size_small _color_primary">{{name}}</p>
            <p class="emd-text _size_small _style_caption emd-link">{{profile.email}} <i class="uil uil-angle-down"></i></p>
          </div>
        </div>
        <button class="emd-btn-close jsMobileMenuClose" @click="toggleMenu"></button>
      </div>
      <div class="emd-mobile-menu__body">
        <div class="emd-accordion">
          <a :href="profileUrl">
            <label class="emd-accordion__label">
              <i class="uil uil-user"></i>
              <span>Meu Perfil</span>
            </label>
          </a>
        </div>
        <div class="emd-accordion _color_danger" @click="logout">
          <label class="emd-accordion__label">
            <i class="uil uil-sign-out-alt"></i>
            <span>Fazer Logout</span>
          </label>
        </div>
      </div>
      <div class="emd-mobile-menu__footer"></div>
    </div>
  </div>
</template>
<script>
import { ProfileInstance } from '@/store'

export default {
  name: 'Header',
  computed: {
    profile: function () {
      return this.$store.state.user.profile
    },
    userInitials () {
      if (this.profile?.user?.first_name) {
        return ProfileInstance.support.getInitials(this.profile.user.first_name, this.profile.user.last_name)
      } else {
        return ''
      }
    },
    lastName () {
      if (this.profile?.user?.last_name) {
        const nameSplit = this.profile?.user?.last_name.split(' ')
        return nameSplit[nameSplit.length - 1]
      } else {
        return ''
      }
    },
    name () {
      return `${this.profile?.user?.first_name} ${this.lastName}`
    },
    classSkeleton () {
      return ['pagarme'].includes(process.env.VUE_APP_THEME) ? 'login-skeleton-pagarme' : ''
    }
  },
  data: () => ({
    idURL: process.env.VUE_APP_ID_ENV,
    profileUrl: `${process.env.VUE_APP_PROFILE_URL}`
  }),
  methods: {
    toggleDesktopMenu () {
      this.$refs.menuContent.classList.toggle('toggleDesktopMenu')
    },
    toggleMenu () {
      document.getElementsByClassName('emd-mobile-menu')[0].classList.toggle('_active')
    },
    logout () {
      this.$store.dispatch('LOGOUT')
      window.location.assign(process.env.VUE_APP_ID_URL)
    }
  },
  mounted () {
    document.addEventListener('mouseup', function (e) {
      const menuItem = Object.values(
        document.getElementsByClassName('jsDropdownContent')
      )

      const showDesktopStatus = menuItem.some(element => element.contains(e.target))

      if (showDesktopStatus) {
        menuItem.classList.remove('toggleDesktopMenu')
      }
    })
  }
}
</script>
<style scoped>
.login-skeleton {
  background-color: transparent;
  background-repeat: no-repeat;
  background-image:
    radial-gradient(circle 24px, #0B3277 100%, transparent 0),
    linear-gradient(#0B3277 40px, transparent 0),
    linear-gradient(#0B3277 40px, transparent 0);
  background-size:
    48px 48px,
    128px 17px,
    228px 17px;
  background-position:
    0 0,
    60px 5px,
    60px 27px;
  height: 48px;
  min-width: 291px;
  position: relative;
  overflow: hidden;
  opacity: 1;
  -webkit-animation: opacity 1s infinite ease-in;
  animation: opacity 1s infinite ease-in;
}
.login-skeleton-pagarme {
  background-image:
    radial-gradient(circle 24px, #d6dde4 100%, transparent 0),
    linear-gradient(#d6dde4 40px, transparent 0),
    linear-gradient(#d6dde4 40px, transparent 0);
}
@keyframes opacity {
  0% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.5;
  }
}
.toggleDesktopMenu {
  opacity: 1;
  visibility: visible;
}
</style>
